export const appHead = {"meta":[{"charset":"utf-8"},{"property":"al:ios:url","content":"mstove://"},{"property":"al:ios:app_store_id","content":"1342134971"},{"property":"al:ios:app_name","content":"STOVE APP"},{"property":"al:android:url","content":"mstove://"},{"property":"al:android:app_name","content":"STOVE APP"},{"property":"al:android:package","content":"com.stove.mstove.google"},{"property":"al:web:url","content":"https://studio.onstove.com"},{"name":"google-site-verification","content":"YAmnkL_CwVMvpzf7vfj8lhG_SKg1jU1qB8HVnTNTh30"},{},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"apple-mobile-web-app-title","content":"STOVE Studio"},{"name":"application-name","content":"STOVE Studio"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-touch-icon-precomposed","content":"/icons/apple-touch-icon.png"},{"name":"description","content":"Create and publish your games with STOVE Studio"},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://studio.onstove.com"},{"property":"og:title","content":"STOVE Studio"},{"property":"og:description","content":"Create and publish your games with STOVE Studio"},{"property":"og:image","content":"https://studio.onstove.com/images/seo/og-image.jpg"},{"property":"og:site_name","content":"STOVE"},{"property":"og:locale","content":"en"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:url","content":"https://studio.onstove.com"},{"name":"twitter:title","content":"STOVE Studio"},{"name":"twitter:description","content":"Create and publish your games with STOVE Studio"},{"name":"twitter:image","content":"https://studio.onstove.com/images/seo/twitter-card.jpg"},{"property":"instapp:owner_id","content":"STOVE Studio"}],"link":[{"rel":"apple-touch-icon","href":"/icons/apple-touch-icon.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/icons/apple-touch-icon.png"},{"rel":"canonical","href":"https://studio.onstove.com"},{"rel":"icon","type":"image/x-icon","href":"/icons/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/icons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/icons/favicon-16x16.png"}],"style":[],"script":[],"noscript":[],"title":"STOVE Studio"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'